
document.addEventListener('click', function(event) {
    if (event.target.closest('.block-swatch')) {
        var styleId = 'dynamic-style';
        var existingStyle = document.getElementById(styleId);

        if (!existingStyle) {
            var style = document.createElement('style');
            style.id = styleId;
            style.innerHTML = 
              `.block-swatch +  label{
                  pointer-events: none;
                  opacity: 0.6;
                }
              ;`
            document.head.appendChild(style);

            setTimeout(function() {
                var styleToRemove = document.getElementById(styleId);
                if (styleToRemove) {
                    document.head.removeChild(styleToRemove);
                }
            }, 2000);
        }
    }
});

function hidePrice() {
    const css = 
  `.sticky-atc-bar__product .f-price {
      opacity: 0 !important;
  }
  ;`
    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    if (!document.querySelector('style[data-vat-hidden]')) {
        style.setAttribute('data-vat-hidden', 'true');
        document.head.appendChild(style);
    }
}

function showPrice() {
    const link = document.querySelector('style[data-vat-hidden]');
    if (link) {
        link.parentNode.removeChild(link);
    }
}

document.addEventListener("DOMContentLoaded", e => {
  main();
    document.addEventListener("click", e => {
    const btn = e.target.closest('#CybotCookiebotDialogBodyButtonsWrapper button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection') ||
        e.target.closest('#CybotCookiebotDialogBodyButtonsWrapper button#CybotCookiebotDialogBodyButtonDecline');

    if (btn) {

    setTimeout(() => {
        if (typeof $ === 'undefined') {
            reloadJQScript();
        }

        setTimeout(() => {
            reloadBssScript();
            main();
        }, 1000);
    }, 1000)
    }

}, 1);
})


setTimeout(() => {
        reloadBssScript();
        main();
}, 4000);


function reloadBssScript() {
  const oldScript = document.querySelector('script[src$="bss-b2b-js.js"]');
  if (oldScript) oldScript.remove();
  const newScript = document.createElement('script');
  newScript.src = oldScript ? oldScript.src.split('?')[0] + '?reload=' + Date.now() : 'https://example.com/js/bss-b2b-js.js';
  newScript.onload = () => console.log('reload bss-b2b-js.js');
  document.body.appendChild(newScript)
}
function reloadJQScript() {
  const oldScript = document.querySelector('script[src$="bss-b2b-jquery-341.js"]');
  if (oldScript) oldScript.remove();
  const newScript = document.createElement('script');
  newScript.src = oldScript ? oldScript.src.split('?')[0] + '?reload=' + Date.now() : 'https://example.com/js/bss-b2b-jquery-341.js';
  newScript.onload = () => console.log('reload bss-b2b-jquery-341.js');
  document.body.appendChild(newScript)
}

function main() {
    if (window.location.pathname.includes('/products/')) {
        let styleAdded = false;
        let counter = 0;
        const selector = ".main-product-form .f-price-item.f-price-item--regular";
        const interval = setInterval(() => {
            const priceItems = document.querySelectorAll(selector);
            const vatPriceElement = document.querySelector(".main-product-form .bss-b2b-product-vat-price-has-vat");

            if (priceItems.length > 0 && typeof(BSS_B2B) !== 'undefined') {
                if (vatPriceElement && !styleAdded && BSS_B2B?.td?.showProductPriceIncludedVat) {
                    BSS_B2B.td.showProductPriceIncludedVat(BSS_B2B, BSS_B2B.shopData, false)
                }
                if (vatPriceElement && getComputedStyle(vatPriceElement).display === 'none' && !styleAdded) {
                    const style = document.createElement('style');
                    style.innerHTML = 
                    `.f-product-single__block:has(.bss-b2b-translation-td-excluded_vat_text) .f-price-item {
                        display: none !important;
                    }
                    .main-product-form .bss-b2b-product-vat,
                    .main-product-form .bss-b2b-product-compare-price-vat {
                        font-size: 1.8rem;
                    }
                ;`
                    document.head.appendChild(style);
                    styleAdded = true;
                }
                counter += 100;
                if (counter >= 10000) {
                    clearInterval(interval);
                }
            } else {
                counter += 100;
                if (counter >= 10000) {
                    clearInterval(interval);
                }
            }
        }, 100);
    }

    function handleCopyPrice() {
        let comparePriceVat = document.querySelector('.main-product-form .bss-b2b-product-compare-price-vat span')?.outerHTML;
        if (!comparePriceVat) {
            comparePriceVat = document.querySelector('s.f-price-item.f-price-item--regular:has([bss-b2b-product-compare-price])')?.outerHTML
        }
        if (comparePriceVat.includes("0,00")) comparePriceVat = null;
        const vatPriceHasVat = document.querySelector('.bss-b2b-product-vat')?.outerHTML;
        if(vatPriceHasVat) {
            document.querySelector('.sticky-atc-bar__product .f-price').innerHTML = comparePriceVat ? comparePriceVat + ' ' + vatPriceHasVat : vatPriceHasVat;
        }
    }
    setTimeout(() => {
        handleCopyPrice();
    }, 1500);
    const input1 = document.querySelector(".f-product-single__blocks input[name='id']");
    if(input1) {
        input1.addEventListener("change", function(e) {
            hidePrice();
            setTimeout(function() {
                handleCopyPrice();
                showPrice();
            }, 2000);
        });
    }
    const select1 = document.querySelector("select[name='id']");
    if(select1) {
        select1.addEventListener("change", function(e) {
            try {
                hidePrice();
                let vId = $(this).val();
                let url = window.location.href;
                let urlObj = new URL(url);
                urlObj.searchParams.set('variant', vId);
                history.replaceState(null, '', urlObj.toString());
                var val = $(".sticky-atc-bar__variant-select option:selected").val();
                // $(".variant-picker__option input[value='" + val +"']").prop("checked", true)
                val = $(".sticky-atc-bar__variant-select option:selected").text();
                // $("variant-button .variant-picker__option-values  label:contains('"+val+"')").click()
                // if(val.split("/").length > 1) {
                //   val = val.split("/")[1]
                // }
                // val = val.replace("\n", "")?.trim();
                $("variant-button .variant-picker__option-values  label").each((i, item) => {
                    if (val.includes($(item).text())) {
                        $(item).trigger("click");
                    }
                })
                // $("variant-button .variant-picker__option-values  label:contains('"+val+"')").trigger("click");
                const scrollPosition = window.scrollY;
                window.scrollTo(0, scrollPosition);
            } catch (e) {} finally {
                setTimeout(() => {
                    handleCopyPrice();
                    showPrice();
                }, 2500);
            }
        })
    }

    const cartDrawerObserver = new MutationObserver(function(mutationList, observer) {
        setTimeout(function() {
            if (BSS_B2B?.cart?.fixer && BSS_B2B?.cp?.changeProductPrice) {
                BSS_B2B.cart.fixer(BSS_B2B.shopData, false, true);
                BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false);
            }
        }, 1000);
    })

    const cartDrawer = document.querySelector("cart-drawer");

    cartDrawer && cartDrawerObserver.observe(document.querySelector("cart-drawer"), {
        attributes: true
    });

    const searchObserver = new MutationObserver(function(mutationList, observer) {
        setTimeout(function() {
            // if (BSS_B2B?.cp?.changeProductPrice) {
            //     BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false);
            // }
            BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
        }, 1000);
    })

    searchObserver.observe(document.querySelector("predictive-search"), {
        attributes: true
    });

    const isCartPage = window.location.pathname === '/cart';

    if (isCartPage && window.screen.width > 750) {

        const checkInterval = 100;
        const loop = setInterval(() => {
            const elements = document.querySelectorAll('td.f-cart-item__totals.right');

            if (elements.length === 2) {
                if (elements[0].parentNode) {
                    elements[0].parentNode.removeChild(elements[0]);
                }

                clearInterval(loop);
            }
        }, checkInterval);

        setTimeout(() => {
            clearInterval(loop);
        }, 6000);
    }

    if (isCartPage) {
        if (window.screen.width < 750) {
            $(".md-down\\:hidden .bss-b2b-cart-vat").remove()
        } else {
            $(".md\\:hidden .bss-b2b-cart-vat").remove()
        }
    }

if(typeof($) !== 'undefined') {
    setTimeout(() => {
        function handleButtonClick(e) {
            e.preventDefault();
            const $button = $(this);
            let oldText = $(this).text();
            $button.css({
                'pointer-events': 'none',
                'opacity': '0.6'
            });
            $button.text("Loading ...");
            setTimeout(() => {
                $button.css({
                    'pointer-events': 'unset',
                    'opacity': '1'
                });
                $button.text(oldText);
            }, 2000);
        }
        // if ($) {
        //     $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
        // }
    }, 2000)
}

} // end onload

document.addEventListener("DOMContentLoaded", e => {
    BSS_B2B.customTriggerCheckoutBtn = function() {
        const locale = $(".weglot-container div[data-l]").attr('data-l');
        if (['es', 'fr', 'pt', 'pl', 'it'].includes(locale)) {
            window.location = '/checkout?locale=' + locale;
        } else {
            window.location = '/checkout?locale=' + Shopify.locale;
        }
    }
});

document.addEventListener("click", function(e) {
    const target = e.target.closest(".f-cart-drawer__buttons a");
    if (target) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        window.location.href = FoxThemeSettings.routes.cart;
    }
}, true);
